/**
 * Usage tracking event handlers
 * 
 * NOTE: Event bus system removed - usage tracking now happens directly in services.
 * This file is kept for backwards compatibility but functions are no-ops.
 */

import { logger } from '@/lib/structured-logger';

/**
 * Initialize usage tracking event subscriptions (no-op)
 */
export function initializeUsageTracking() {
  logger.info('Usage tracking initialization (no-op - tracking handled in services)');
}

/**
 * Cleanup function for tests (no-op)
 */
export function cleanupUsageTracking() {
  // No-op
}
